import BottomNavBar from "@/components/bottomBar";
import { Navbar } from "@/components/navbar";

export default function DefaultLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="relative flex flex-col h-screen">
      <Navbar />
      <main className="container mx-auto max-w-6xl px-3 mt-1 flex-grow">
        {children}
      </main>
      <BottomNavBar />
    </div>
  );
}
